module.exports = __webpack_public_path__ + "static/media/right_arrow.c9887ccf.svg";